import React, { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { DialogTitle } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'
import Dialog from '@mui/material/Dialog'

interface IProps {
  title: string
  content: string | ReactElement
  submitButtonText?: string
  cancelButtonText?: string
  onClose(): void
  onSubmit(values: any): Promise<void>
}

const InfoDialog: React.FC<IProps> = ({ onClose, onSubmit, title, content, submitButtonText, cancelButtonText }) => {
  const { t } = useTranslation()
  return (
    <Dialog onClose={onClose} maxWidth='sm' open={true}>
      <DialogTitle>
        <span className='text-capitalize font-semibold'>{title}</span>
        <span className='absolute right-10 top-10'>
          <IconButton onClick={onClose} size='medium' title={t('close', 'Close')}>
            <CloseIcon fontSize='large' />
          </IconButton>
        </span>
      </DialogTitle>
      <DialogContent className='w-600 max-w-full' dividers>
        {content}
      </DialogContent>
      <DialogActions>
        <Button type='button' variant='outlined' onClick={onClose}>
          {cancelButtonText || t('button.cancel', 'Cancel')}
        </Button>
        <Button type='submit' variant='contained' color='secondary' onClick={onSubmit}>
          {submitButtonText || t('button.submit', 'Submit')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default InfoDialog
